import { isArray } from 'util';
import { mapCollection, sortByNumber } from '../../utils/collection.utils';
import { SaleOrderLineProduct } from '../sale-order-line-product';
import { parseNumber } from '../../utils/number.utils';

export class SaleOrderLineProductBuilder {

  static fromJson(json): SaleOrderLineProduct {
    return (json) ? new SaleOrderLineProduct(
      json.hash,
      json.productHash,
      json.productName,
      json.productCode,
      json.productDescription,
      json.productNeedSerialNumber,
      json.productWeight,
      parseNumber(json.amount),
      parseNumber(json.discountType),
      parseNumber(json.discountNumber),
      parseNumber(json.discountAppliedAmount),
      parseNumber(json.commercialMargin)
    ) : null;
  }

  static fromJsonList(list): SaleOrderLineProduct[] {
    return (isArray(list)) ? sortByNumber('quantity', mapCollection(SaleOrderLineProductBuilder.fromJson, list)) : [];
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/ubaristi-app-test/workspace/src/app/core/models/builders/sale-order-line-product-builder.ts